import $ from "jquery";

const productFilter = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const productFilterElement = $(".js-product-filter");

    if (productFilterElement.length === 0) {
      return; // Keluar dari fungsi jika elemen tidak ditemukan
    }

    const listLevel = $(".js-product-filter .wpf_hierachy > li");
    const listLevel2 = $(
      ".js-product-filter .wpf_hierachy > li .wpf_level_2 > li"
    );
    const listLevel2HasChildren = $(
      ".js-product-filter .wpf_hierachy > li .wpf_level_2 > li"
    ).has(".wpf_level_3");

    listLevel.find(" > input").prop("disabled", true);
    // listLevel2.find(" > input").prop("disabled", true);
    listLevel2.find(" > input").attr("readonly", false);
    listLevel2HasChildren.addClass("has-children");

    listLevel2HasChildren.find("> label").on("click", function () {
      $(this).parent().toggleClass("active");
    });

    // get slug product category
    // const linkElement = document.querySelector(".trigger-slug-product-cat a");
    // const link = linkElement.getAttribute("href");
    // const slug = link.split("/");
    // const linkProductCategory = slug[3];

    // listLevel2.each(function () {
    //   if (!$(this).children("ul.wpf_level_3").length) {
    //     $(this).addClass("link");
    //     const inputVal = $(this).children("input").val();
    //     $(this)
    //       .children("label")
    //       .each(function () {
    //         const labelText = $(this).text();
    //         $(this).replaceWith(
    //           "<a href='/" +
    //             linkProductCategory +
    //             "/" +
    //             inputVal +
    //             "'>" +
    //             labelText +
    //             "</a>"
    //         );
    //       });
    //   }
    // });
  };

  init();
};

try {
  productFilter();
  // LinkRedirect();
} catch (error) {
  console.log(error);
}
